import { Component, OnInit } from '@angular/core';
import { relativeTimeThreshold } from 'moment';
import { FormularService } from 'src/app/Services/formular.service';

@Component({
  selector: 'app-gip-logon-maint',
  templateUrl: './gipLogonMaint.component.html',
  styleUrls: ['./gipLogonMaint.component.css']
})
export class GipLogonMaintComponent implements OnInit {

  constructor(private formularService:FormularService) { }

  warning: string;

  ngOnInit(): void {
    this.getWarningText();
  }

  getWarningText(){(
    this.formularService.getData([`Admin/V_GIP_TEXT_T?$filter=TEXTID eq 'AM_MSG'`], (data) => this.warning = data.TEXT));
  }
}
